const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT || 'local';

export const BASE_URL = ENVIRONMENT === 'prod' 
    ? 'https://gypsy-tourism-server.onrender.com' 
    : 'http://localhost:5000';

export const rootApi = {
    tours: `${BASE_URL}/tours`,
    bookingTour: `${BASE_URL}/bookingTour`,
    services: `${BASE_URL}/services`,
    serviceRequests: `${BASE_URL}/serviceRequests`,
    health: `${BASE_URL}/health`,
};

